export const config = {
    authority: 'https://dev-as-identity-server.locate2u.com/',
    redirect_uri: 'https://dev-as-app-portal.locate2u.com/callback',
    post_logout_redirect_uri: 'https://dev-as-app-portal.locate2u.com/login',
    silent_redirect_uri: 'https://dev-as-app-portal.locate2u.com/static/silent-renew.html',
    billing_redirect_url: 'https://dev-as-app-portal.locate2u.com/dashboard',
    billing_customer_portal_url: 'https://billing.test.locate2u.com'
};
